import React, { useContext, useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './NavBar.css';

const NavBar = () => {
  const { currentUser, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navbarRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    // Close dropdown when menu is toggled
    setDropdownOpen(false);
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  // Close menu when clicking a link
  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  // Handle click outside to close menu and dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close dropdown if clicked outside
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      
      // Close mobile menu if clicked outside
      if (navbarRef.current && 
          !navbarRef.current.contains(event.target) && 
          menuOpen) {
        setMenuOpen(false);
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Clean up
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  // Close menu on window resize (when switching from mobile to desktop)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && menuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [menuOpen]);

  return (
    <nav className="navbar" ref={navbarRef}>
      <div className="navbar-logo">
        <Link to="/" className="nav-link">TradingCard.Life</Link>
      </div>
      
      {/* Hamburger menu button for mobile */}
      <button 
        className="navbar-mobile-toggle" 
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
      >
        <div className={`hamburger-icon ${menuOpen ? 'open' : ''}`}>
          <span className="hamburger-bar hamburger-bar-1"></span>
          <span className="hamburger-bar hamburger-bar-2"></span>
          <span className="hamburger-bar hamburger-bar-3"></span>
        </div>
      </button>
      
      <div className={`navbar-links ${menuOpen ? 'show' : ''}`}>
        {currentUser ? (
          <>
            <Link to={`/@${currentUser.username}`} className="nav-link" onClick={handleLinkClick}>My Homepage</Link>
            <Link to="/trading-card-sets" className="nav-link" onClick={handleLinkClick}>Trading Card Sets</Link>
          </>
        ) : (
          <Link to="/trading-card-sets" className="nav-link" onClick={handleLinkClick}>Trading Card Sets</Link>
        )}
        
        {currentUser ? (
            <div 
              className={`navbar-dropdown ${dropdownOpen ? 'show' : ''}`}
              ref={dropdownRef}
            >
              <button 
                className="navbar-dropdown-btn"
                onClick={toggleDropdown}
                aria-expanded={dropdownOpen}
              >
                {currentUser.username}
                <span className="dropdown-arrow"></span>
              </button>
              <div className="navbar-dropdown-content">
                <Link to="/profile" className="nav-link" onClick={handleLinkClick}>Edit Profile</Link>
                <Link to="/" className="nav-link" onClick={(e) => { e.preventDefault(); handleLogout(); }}>Logout</Link>
              </div>
            </div>
        ) : (
          <>
            <Link to="/login" className="nav-link" onClick={handleLinkClick}>Login</Link>
            <Link to="/register" className="nav-link" onClick={handleLinkClick}>Register</Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default NavBar;